import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Ftnd
 *
 * 니코틴 의존도 평가 모델
 */

export const FtndChoice = types.model('ftndChoice', {
  ftndChoiceSid: types.maybeNull(types.number),
  ftndSid: types.maybeNull(types.number),
  order: types.maybeNull(types.number),
  ftndChoiceTitle: types.maybeNull(types.string),
  score: types.maybeNull(types.number),
  langCd: types.maybeNull(types.string),
});
type TFtndChoice = Instance<typeof FtndChoice>;
export interface IFtndChoice extends TFtndChoice {}
export const createFtndChoice = () => types.optional(FtndChoice, {} as TFtndChoice);

export const Ftnd = types
  .model('Ftnd')
  // --------------------------------------------------------------------------
  .props({
    ftndSid: types.maybeNull(types.number),
    ftndQuest: types.maybeNull(types.string),
    order: types.maybeNull(types.number),
    subjectiveYn: types.maybeNull(types.string),
    multiSelectYn: types.maybeNull(types.string),
    langCd: types.maybeNull(types.string),
    ftndChoices: types.maybeNull(types.array(FtndChoice)),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model ftnd --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IFtnd;
      (Object.keys(newProps) as TFtndKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TFtnd = Instance<typeof Ftnd>;
type TFtndSnapshot = SnapshotOut<typeof Ftnd>;

export interface IFtnd extends TFtnd {}
export type TFtndKeys = keyof TFtndSnapshot & string;
export interface IFtndSnapshot extends TFtndSnapshot {}
export const createFtnd = () => types.optional(Ftnd, {} as TFtnd);
